import React, { useEffect, useState } from "react";
import logoJMD from "../../assets/img/logo-jmd.png";
import logokemenag from "../../assets/img/logo-kemenang.png";

import axios from "axios";
import { toast } from "react-toastify";

const Footer = () => {
	const [logos, setLogos] = useState([]);

	useEffect(() => {
		const fetchLogoData = async () => {
			try {
				const response = await axios.get("/api_w/logo", {
					headers: {
						db_name: process.env.REACT_APP_DB_NAME,
					},
				});
				const logoData = response.data.data || [];
				const defaultLogos = [
					{ id: 1, url: logokemenag },
					{ id: 2, url: logoJMD },
				];
				const logosDefaults = defaultLogos.map((defaultLogo) => {
					const dataLogo = logoData.find((logo) => logo.id === defaultLogo.id);
					return dataLogo || defaultLogo;
				});
				setLogos(logosDefaults);
			} catch (error) {
				toast.error(error.response?.data?.message || error.message);
				setLogos([
					{ id: 1, url: logokemenag },
					{ id: 2, url: logoJMD },
				]);
			}
		};
		fetchLogoData();
	}, []);

	return (
		<footer
			className="relative text-gray-300 overflow-hidden font-sans"
			style={{ backgroundColor: "#308C41" }}
		>
			{/* Background Glows */}
			<div className="absolute top-0 left-0 w-[450px] h-[450px] bg-green-600/10 blur-[120px] rounded-full pointer-events-none z-0" />
			<div className="absolute bottom-0 right-0 w-[550px] h-[550px] bg-green-500/10 blur-[150px] rounded-full pointer-events-none z-0" />

			{/* Main Footer Container */}
			<div className="relative z-10 max-w-7xl mx-auto px-8 py-16">
				<div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
					{/* Column 1: Logo & Address */}
					<div className="space-y-6">
						{/* Logo Container */}
						<div className="flex gap-3 items-center">
							{logos.map((logo) => (
								<img
									key={logo.id}
									className="h-16 w-auto object-contain"
									src={logo.url}
									alt="Logo"
									onError={(e) => {
										e.target.src = logo.id === 1 ? logokemenag : logoJMD;
									}}
								/>
							))}
						</div>

						{/* Address */}
						<div className="space-y-4">
							<p className="text-gray-100 text-sm leading-relaxed max-w-xs justify-start">
								Jl. Sukonandi No.8, Semaki, Kec. Umbulharjo, Kota Yogyakarta,
								Daerah Istimewa Yogyakarta, 55166
							</p>

							{/* Social Media Icons */}
							<div className="flex items-center gap-3 pt-2">
								<a
									href="https://www.instagram.com/jogjamadrasahdigital"
									target="_blank"
									rel="noopener noreferrer"
									className="text-gray-100 hover:text-green-300 transition-colors"
								>
									<svg
										className="w-5 h-5"
										fill="currentColor"
										viewBox="0 0 24 24"
									>
										<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
									</svg>
								</a>
								<a
									href="https://youtube.com/@jogjamadrasahdigital"
									target="_blank"
									rel="noopener noreferrer"
									className="text-gray-100 hover:text-green-300 transition-colors"
								>
									<svg
										className="w-5 h-5"
										fill="currentColor"
										viewBox="0 0 24 24"
									>
										<path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
									</svg>
								</a>
								<a
									href="https://wa.me/6287739532870"
									target="_blank"
									rel="noopener noreferrer"
									className="text-gray-100 hover:text-green-300 transition-colors"
								>
									<svg
										className="w-5 h-5"
										fill="currentColor"
										viewBox="0 0 24 24"
									>
										<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
									</svg>
								</a>
								<a
									href="mailto:kanwildiy@kemenag.go.id"
									className="text-gray-100 hover:text-green-300 transition-colors"
								>
									<svg
										className="w-5 h-5"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
										/>
									</svg>
								</a>
							</div>
						</div>
					</div>

					{/* Column 2: Program */}
					<div className="space-y-4">
						<h3 className="font-bold text-white text-sm">Program</h3>
						<ul className="space-y-3 text-sm text-gray-200">
							<li>
								<a href="#" className="hover:text-green-300 transition-colors">
									Madrasah Cerdas Mandiri
								</a>
							</li>
							<li>
								<a href="#" className="hover:text-green-300 transition-colors">
									Orang Tua Cerdas Mandiri
								</a>
							</li>
						</ul>
					</div>

					{/* Column 3: Bantuan dan Panduan */}
					<div className="space-y-4">
						<h3 className="font-bold text-white text-sm">
							Bantuan dan Panduan
						</h3>
						<ul className="space-y-3 text-sm text-gray-200">
							<li>
								<a href="#" className="hover:text-green-300 transition-colors">
									Kebijakan Privasi
								</a>
							</li>
							<li>
								<a href="#" className="hover:text-green-300 transition-colors">
									Syarat & Ketentuan
								</a>
							</li>
							<li>
								<a href="#" className="hover:text-green-300 transition-colors">
									FAQ
								</a>
							</li>
						</ul>
					</div>

					{/* Column 4: Kontak Kami */}
					<div className="space-y-4">
						<h3 className="font-bold text-white text-sm">Kontak Kami</h3>
						<div className="space-y-3">
							<p className="text-sm text-gray-200">
								<a
									href="mailto:kanwildiy@kemenag.go.id"
									className="hover:text-green-300 transition-colors"
								>
									kanwildiy@kemenag.go.id
								</a>
							</p>
							<a
								href="https://wa.me/6287739532870"
								target="_blank"
								rel="noopener noreferrer"
								className="inline-block px-4 py-2 rounded-lg border border-green-300 text-green-300 hover:bg-green-400/10 transition-colors text-xs font-semibold"
							>
								Hubungi Kami
							</a>
						</div>
					</div>
				</div>
			</div>

			{/* Watermark Background Text */}
			<div className="absolute bottom-0 left-0 w-full h-auto pointer-events-none select-none z-0 opacity-5">
				<div className="relative w-full h-[200px] flex items-center justify-center overflow-hidden">
					<h2 className="text-9xl font-bold text-white text-center whitespace-nowrap">
						Jogja Madrasah Digital
					</h2>
				</div>
			</div>

			{/* Bottom Bar */}
			<div
				className="relative py-6"
				style={{ borderTopColor: "#2d7a38", borderTopWidth: "1px" }}
			>
				<div className="max-w-7xl mx-auto px-8">
					<p className="text-green-100/70 text-xs">
						&copy; {new Date().getFullYear()} Jogja Madrasah Digital — Bidang
						Dikmad Kanwil Kemenag DIY. All Rights Reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
